import '@fontsource/arimo';
import '@fontsource/arimo/700.css';

import '@fontsource/poppins';
import '@fontsource/poppins/600.css';

// eslint-disable-next-line @typescript-eslint/no-var-requires
export const wrapRootElement = require('./src/wrapRootElement').wrapRootElement;
